export default __webpack_public_path__ + "static/media/work7.3a5e2f0e.png";